import React from "react";
import { Typography, TextField, Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import InfoPopover from "../../../../utils/informationButton";

const CompassResponseComponent = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <Typography variant="h6" className={props.classes.responseTitle}>
          {t("newEnigma.responses")}
        </Typography>
        <InfoPopover
          title={t("newEnigma.response_compass")}
          text={t("newEnigma.response_compass_info")}
          src="/images/reponse-boussole.webp"
        />
      </Box>

      <TextField
        required
        id="standard-helperText"
        label="Orientation"
        variant="outlined"
        type="number"
        size="small"
        inputProps={{
          min: 0,
          max: 360,
        }}
        minRows={2}
        className={props.classes.textfieldResponses}
        style={{
          width: "100%",
        }}
        defaultValue={props.state.formDatas.compass}
        onChange={props.handleResponsesCompassChange}
        key={props.state.enigmaLoaded ? "compassNotLoaded" : "compassLoaded"}
      />
    </>
  );
};

export default CompassResponseComponent;
